import { convertDateFromStringToMoment, entityToLabelValue } from 'Core/utils'

import { PurchaseOrder } from 'Portals/Customer/entities'

export const formatBillingLocationAddressOption = (
	billingLocationAddress: PurchaseOrder.BillingLocationAddress
): LabelValue<number> => ({
	label: `${[
		billingLocationAddress.addressLine1,
		billingLocationAddress.addressLine2,
		billingLocationAddress.city
	]
		.filter(Boolean)
		.join(', ')} ${[billingLocationAddress.state, billingLocationAddress.zip]
		.filter(Boolean)
		.join(' ')}`,
	value: billingLocationAddress.customerId
})

export const getDefaultFormValues = (
	data: PurchaseOrder.Detailed,
	getCurrencyCodeByCustomerId: (customerId: BasicNumber) => BasicString,
	billingLocationAddressOptions: LabelValue<number>[]
): PurchaseOrder.Form => ({
	customerId: billingLocationAddressOptions?.find(
		(address) => address.value === data.customerId
	) as LabelValue<number>,
	serviceSitesIds: data.serviceSites.map(entityToLabelValue),
	purchaseOrderNumber: data.purchaseOrderNumber,
	amount: data.amountLeft,
	file: null,
	fileName: data.documentName,
	currency: getCurrencyCodeByCustomerId(data.customerId),
	effectiveStartDate: convertDateFromStringToMoment(data.effectiveStartDate),
	effectiveEndDate: convertDateFromStringToMoment(data.effectiveEndDate)
})
